import DOMPurify from "dompurify";
import { Marked, Renderer } from "marked";

const renderer = new Renderer();

// Chat links should always open in a new tab so people don't lose their edit
// session when the assistant shares docs or examples.
renderer.link = ({ href, title, text }) => {
  return `<a href="${href}" target="_blank" rel="noopener noreferrer"${title ? ` title="${title}"` : ""}>${text}</a>`;
};

renderer.table = ({ header, rows, align }) => {
  let html = '<table class="table table-sm table-bordered mb-0">\n';

  if (header && header.length > 0) {
    html += "<thead>\n<tr>\n";
    for (let i = 0; i < header.length; i++) {
      const alignAttr = align[i] ? ` align="${align[i]}"` : "";
      const cellHtml = markdown.parseInline(header[i].text, {
        async: false,
      });
      html += `  <th${alignAttr}>${cellHtml}</th>\n`;
    }
    html += "</tr>\n</thead>\n";
  }

  if (rows && rows.length > 0) {
    html += "<tbody>\n";
    for (const row of rows) {
      html += "<tr>\n";
      for (let i = 0; i < row.length; i++) {
        const alignAttr = align[i] ? ` align="${align[i]}"` : "";
        const cellHtml = markdown.parseInline(row[i].text, {
          async: false,
        });
        html += `  <td${alignAttr}>${cellHtml}</td>\n`;
      }
      html += "</tr>\n";
    }
    html += "</tbody>\n";
  }

  html += "</table>";
  return '<div class="table-responsive">\n' + html + "\n</div>";
};

const markdown = new Marked({
  async: false,
  breaks: true,
  gfm: true,
  renderer,
});

export function renderChatMarkdown(content: string): string {
  const html = markdown.parse(content);
  return DOMPurify.sanitize(html, {
    ADD_ATTR: ["target", "rel"],
  });
}
